import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import productsData from "../data/products.json";
import { useProductPrice } from "../services/amazonApi";

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  // Get unique categories
  const categories = [
    "all",
    ...new Set(productsData.products.map((product) => product.category)),
  ];

  // Function to extract ASIN from Amazon URL
  const getAsinFromUrl = (url) => {
    const match = url.match(/\/dp\/([A-Z0-9]{10})/);
    return match ? match[1] : null;
  };

  // Function to get Amazon image URL from ASIN
  const getAmazonImageUrl = (asin) => {
    return `https://m.media-amazon.com/images/P/${asin}._AC_SL500_.jpg`;
  };

  // Filter products based on selected category
  const filteredProducts = productsData.products.filter(
    (product) =>
      selectedCategory === "all" || product.category === selectedCategory
  );

  const ProductPrice = ({ asin }) => {
    const { price, loading, error } = useProductPrice(asin);

    if (loading) {
      return <Spinner animation="border" size="sm" />;
    }
    if (error) {
      return <span className="text-muted">{price}</span>;
    }
    return <span className="text-primary fw-bold">{price}</span>;
  };

  return (
    <Container className="py-5">
      <h1 className="mb-4">Recommended Sourdough Equipment</h1>

      <Form.Group className="mb-4">
        <Form.Label>Filter by Category:</Form.Label>
        <Form.Select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {categories.map((category) => (
            <option key={category} value={category}>
              {category === "all" ? "All Categories" : category}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Row xs={1} md={2} lg={3} className="g-4">
        {filteredProducts.map((product) => {
          const asin = getAsinFromUrl(product.affiliateLink);
          const imageUrl = asin ? getAmazonImageUrl(asin) : "";

          return (
            <Col key={product.id}>
              <Card className="h-100 shadow-sm">
                <Card.Img
                  variant="top"
                  src={imageUrl}
                  alt={product.name}
                  style={{
                    height: "200px",
                    objectFit: "contain",
                    padding: "1rem",
                  }}
                  onError={(e) => {
                    // Fallback if the image fails to load
                    e.target.src =
                      "https://via.placeholder.com/300x300?text=Product+Image";
                  }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title>{product.name}</Card.Title>
                  <Card.Text>{product.description}</Card.Text>
                  <Card.Text>{asin && <ProductPrice asin={asin} />}</Card.Text>
                  <Button
                    variant="primary"
                    href={product.affiliateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto"
                  >
                    View on Amazon
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>

      <div className="mt-4 text-muted small">
        <p>Note: As an Amazon Associate, we earn from qualifying purchases.</p>
      </div>
    </Container>
  );
};

export default Products;
